import React from "react";
import dayjs from "dayjs";
import { Form } from "antd";
import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TimePicker from "@/common/elements/TimePicker";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";

const JailIncidentInmateAdmitsGuilt = ({ data, disabled = false }) => {
  const initialValues = {
    accept: data?.accept || false,
    acceptOfficer: data?.acceptByStaffID || "",
    acceptDate: data?.acceptDate ? dayjs(data.acceptDate, "DD/MM/YYYY") : null,
    acceptTime: data?.acceptTime ? dayjs(data.acceptTime, "HH:mm") : null,
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Inmate Admits Guilt and Accepts Consequences</span>
      </StyledSectionHeading>

      <Form name="jailIncidentInmateAdmitsGuilt" initialValues={initialValues}>
        <StyledGridRow gutter={16}>
          <StyledGridCol>
            <FormItem
              label="Accept?"
              layout="horizontal"
              labelPostion="label-right"
              paddingTop="24px"
              name="accept"
              valuePropName="checked"
            >
              <Checkbox disabled={disabled} />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={7}>
            <FormItem label="Accept Officer" name="acceptOfficer">
              <Select
                options={getOptionsFromRefList("", true, false, true)}
                disabled={disabled}
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={5}>
            <FormItem label="Accept Date" name="acceptDate">
              <CommonDatePicker
                showTime={false}
                format="DD/MM/YYYY"
                disabled={disabled}
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={5}>
            <FormItem label="Accept Time" name="acceptTime">
              <TimePicker disabled={disabled} />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};

export default JailIncidentInmateAdmitsGuilt;
